// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>
        <a href="https://github.com/your-github">GitHub</a> |{' '}
        <a href="https://www.linkedin.com/in/your-linkedin">LinkedIn</a> |{' '}
        <a href="https://stackoverflow.com/users/your-stackoverflow">Stack Overflow</a>
      </p>
    </footer>
  );
};

export default Footer;